export default class OffersRegions {
  static empty() {
    return new OffersRegions([])
  }

  constructor(regions = []) {
    this.regions = regions
  }
}
